<script setup>
import { inject } from 'vue';
import UiFormField from '@/components/ui/UiFormField.vue';
import SettingsSection from '@/components/settings/SettingsSection.vue';
import { SCHOOL_SETTINGS_KEY } from '@/composables/useSchoolSettingsForm';

const KEYS = ['emailSenderName'];
const { form, saving, savedAt, isDirty, reset, save } = inject(SCHOOL_SETTINGS_KEY);
</script>

<template>
  <SettingsSection
    title="Email"
    description="How verification, password and account emails are sent."
    :dirty="isDirty(KEYS)"
    :saving="saving === 'email'"
    :saved-at="savedAt.email || 0"
    @save="save('email', KEYS)"
    @reset="reset(KEYS)"
  >
    <UiFormField
      label="Sender name"
      description="Shown as the sender in the recipient's inbox, followed by &quot;(No Reply)&quot;. The sending address is configured on the server."
      v-slot="{ id }"
    >
      <v-text-field :id="id" v-model="form.emailSenderName" maxlength="150" hide-details="auto" />
    </UiFormField>
  </SettingsSection>
</template>
